// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Z8_v5","filesListContainer":"PosDisputesFiles_filesListContainer__bFgtp","filesButton":"PosDisputesFiles_filesButton__2Nv9n"};